import { useState } from "react";
import SongRow from "./SongRow";

const GENRES = [
  { label: "All",        value: "all",        color: "#ff2d9b" },
  { label: "Pop",        value: "pop",        color: "#7adb2a" },
  { label: "Electronic", value: "electronic", color: "#9b27af" },
  { label: "Rock",       value: "rock",       color: "#ff7a00" },
];

const LIGHT = ["#7adb2a", "#00d4e8", "#ffd000"];

export default function SongList({ songs, current, onSelect, onAddToQueue, userId }) {
  const [filter, setFilter] = useState("all");

  const filtered = filter === "all"
    ? songs
    : songs.filter(s => s.genre?.toLowerCase() === filter);

  return (
    <div className="song-list">
      <div className="filters-wrap">
        <div className="filters">
          {GENRES.map(g => (
            <button
              key={g.value}
              className={`chip ${filter === g.value ? "on" : ""}`}
              style={filter === g.value ? {
                background: g.color,
                borderColor: g.color,
                color: LIGHT.includes(g.color) ? "#111" : "#fff",
              } : {}}
              onClick={() => setFilter(g.value)}
            >
              {g.label}
            </button>
          ))}
        </div>
      </div>
      <div className="tracks">
        {filtered.map(song => (
          <SongRow
            key={song.id}
            song={song}
            isActive={current?.id === song.id}
            onSelect={onSelect}
            onAddToQueue={onAddToQueue}
            userId={userId}
          />
        ))}
      </div>
    </div>
  );
}